// extracted by mini-css-extract-plugin
export default {"containerAboutLoader":"textSlider_containerAboutLoader__WJW9b"};